import { ComponentGallery } from "~/components/ComponentGallery/ComponentGallery";
import * as React from 'react';
export default {
  ComponentGallery,
  React
};